var React = require('react');

function Gatsby (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0004 0C4.4349 0 0 4.4349 0 9.99958C0 15.5643 4.4349 20.0008 9.99958 20.0008C15.5643 20.0008 20 15.5659 20 10.0004C20 4.4349 15.5659 0 10.0004 0ZM2.17368 10.0871L9.9137 17.8272C5.65223 17.8272 2.17368 14.3486 2.17368 10.0871ZM11.7397 17.6529L2.34794 8.26114C3.1292 4.78259 6.26089 2.17368 9.99958 2.17368C11.2358 2.17609 12.4541 2.46854 13.5567 3.02752C14.6593 3.58649 15.6154 4.39639 16.348 5.39209L15.2182 6.3476C14.6291 5.48536 13.8374 4.7808 12.9125 4.29572C11.9877 3.81063 10.958 3.55981 9.9137 3.56526C8.5931 3.55678 7.30323 3.96357 6.22641 4.72813C5.1496 5.49268 4.34032 6.57633 3.91295 7.82591L12.0874 16.0012C14.0885 15.305 15.6526 13.5665 16.0879 11.4787H12.696V10.0004H17.8272C17.8272 13.7399 15.2182 16.8708 11.7397 17.6529Z"}));
}

Gatsby.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Gatsby;

Gatsby.default = Gatsby;
